import React from 'react';
import CampaignEditor from '@/components/campaigns/CampaignEditor';

/**
 * Campaign editor, create mode (quantix-api/docs/campaigns/TASKS.md, task W3):
 * source -> fields -> mapping -> defaults -> review. Only step 1 (source) is
 * interactive here; creating the campaign hands off to the edit route at step 2.
 */
const CampaignCreatePage: React.FC = () => {
    return <CampaignEditor mode="create" />;
};

export default CampaignCreatePage;
